//@flow

import React from 'react';
import AdditionalResources from './AdditionalResources/AdditionalResources';
import AdHocServices from './AdHocServices/AdHocServices';
import ContactSupport from './ContactSupport/Support';
import OrderCounter from './OrderCounter';
import {useStoreInfo} from '../../store/utils';

export default function SidebarFooter() {
  const store = useStoreInfo();

  if (!store) return null;

  const showOrderCounter =
    store.storeTier.name === 'TIER_11' ||
    (store.storeTier.name === 'TIER_22' &&
      store.storePreviousTier &&
      store.storePreviousTier.name === 'TIER_11');

  return (
    <>
      <div>
        <AdHocServices />
        <ContactSupport />
        <AdditionalResources />
      </div>
      {showOrderCounter && (
        <div>
          <OrderCounter />
        </div>
      )}
    </>
  );
}
